// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  language_default: 'en',
  second_title: ' | XRSupport',
  password_min_length: 8,
  api: {
    base_url: 'https://api.xrsupport.online/api/v1',
    url_connect_check: "https://web-rtc-signaling-azure.digitalmens.dev/backoffice/connections"
  },
  nodeHost: 'https://web-rtc-signaling-azure.digitalmens.dev',
  websocket: {
    url_web_socket: "wss://web-rtc-signaling-azure.digitalmens.dev",
    broadcast_channel: "xrsupport-channel"
  },
  websocketHost: 'web-rtc-signaling-azure.digitalmens.dev',
  websocketUrl: 'wss://web-rtc-signaling-azure.digitalmens.dev',
  home_page: '/dashboard',
  avatar_url: '/assets/images/users/user-img.jpg',
  file_accepted_files: [
    'application/pdf',
    'image/jpeg',
    'image/png',
  ],
  rtcConfig: {
    sdpSemantics: 'unified-plan',
    iceServers: [
      {
        urls: 'turn:turnserver-azure.digitalmens.dev:3478',
        username: 'turn_digital',
        credential: 'Digital_2024!'
      },
      {
        urls: 'stun:stun.l.google.com:19302'
      }
    ]
  },
  language_list: [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Italiano',
      code: 'it',
      icon: '/assets/images/flag/icon-flag-it.svg',
    },
    {
      language: 'Deutsch',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ]
};
